import { AppleIcon, ArrowShortIcon, GoogleIcon } from 'assets/icons'
import Button from 'components/UI/Button'
import Card from 'components/Wizard/Card'
import { t } from 'helpers'
import s from './index.module.scss'
import { useAppStore } from 'store'

const Form = (): JSX.Element => {
	const handleLogin = (type: 'google' | 'apple' | 'facebook'): void => {
		localStorage.setItem('provider', type)

		const redirectLink = `${
			window.location.href.includes('localhost')
				? 'http://localhost:3000'
				: 'https://' + window.location.host
		}/join/login?token={token}`

		const { endpoints } = useAppStore.getState()

		const links = {
			google: endpoints?.CustomSignInGoogle,
			apple: endpoints?.CustomSignInApple,
			facebook: endpoints?.CustomSignInFacebook,
		}

		const link = links[type] + `?state=webredirection%23%23${redirectLink}`

		window.location.href = link
	}

	return (
		<Card className={s.container}>
			<div className={s.wrapper}>
				<div className={s.titles}>
					<h2 className="h2-m">{t('APP_LOGIN_WELCOME_TITLE')}</h2>
					<span>{t('APP_LOGIN_WELCOME_SUBTITLE')}</span>
				</div>
				{/* <div className={s.buttonWrapper}>
					<Button variant="outlined" onClick={() => handleLogin('facebook')}>
						<div style={{ display: 'flex' }}>
							<FacebookIcon width="24" height="24" />
						</div>
						{t('APP_FACEBOOK_AUTH')}
						<div style={{ display: 'flex' }}>
							<ArrowShortIcon />
						</div>
					</Button>
				</div> */}
				<div className={s.buttonWrapper}>
					<Button variant="outlined" onClick={() => handleLogin('google')}>
						<div style={{ display: 'flex' }}>
							<GoogleIcon />
						</div>
						{t('APP_GOOGLE_AUTH')}
						<div style={{ display: 'flex' }}>
							<ArrowShortIcon />
						</div>
					</Button>
				</div>
				<div className={s.buttonWrapper}>
					<Button variant="outlined" onClick={() => handleLogin('apple')}>
						<div style={{ display: 'flex' }}>
							<AppleIcon />
						</div>
						{t('APP_APPLE_AUTH')}
						<div style={{ display: 'flex' }}>
							<ArrowShortIcon />
						</div>
					</Button>
				</div>
			</div>
		</Card>
	)
}

export default Form
